module.exports = __webpack_public_path__ + "img/influencer.50042cc0.svg";